import { toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue";
import { computed, onMounted, ref, provide } from 'vue';
import HorizontalAsinShowCase from './HorizontalAsinShowCase.vue';
import VerticalAsinShowCase from './VerticalAsinShowCase.vue';
import { useLess } from '@/models/hooks';
import { getNewCustomerCoupon } from '@/utils/promotionCommon';
import { useI18n } from 'vue-i18n';
import { closeToast } from 'vant';
import { useRoute } from 'vue-router';
import { clickEvents } from '@/configs/awsRumConfig';
import { awsRumHandler } from '@/utils/awsRumHandler.js';
import { SHOW_TYPE, LAYOUT_TYPE, TEXT_BOLD_TYPE } from '@/configs/views/landingPage.js';
import { showToastText, addCartList } from '@/utils/common';
const SHOW_TOAST_DURATION = 1000; // 1000ms

export default {
  __name: 'AsinShowcase',
  props: {
    properties: {
      type: Object,
      default: () => null
    }
  },
  setup(__props) {
    const props = __props;
    useLess('views/landingPage/asinShowcase/AsinShowcase.less');
    const {
      t
    } = useI18n();
    const route = useRoute();
    const couponInfo = ref(null);
    provide('couponInfo', couponInfo);
    const asinShowcaseStyle = computed(() => {
      return {
        paddingBottom: `${props.properties.bottomSpacing || 0}px`
      };
    });
    const masterTitleStyle = computed(() => {
      return {
        fontSize: `${props.properties.masterTextSize}px`,
        color: props.properties.masterColor,
        fontWeight: TEXT_BOLD_TYPE[props.properties.masterBoldType]
      };
    });
    const deputyTitleStyle = computed(() => {
      return {
        fontSize: `${props.properties.deputyTextSize}px`,
        color: props.properties.deputyColor,
        fontWeight: TEXT_BOLD_TYPE[props.properties.deputyBoldType]
      };
    });
    const asinBadge = computed(() => {
      var _props$properties;
      return (_props$properties = props.properties) === null || _props$properties === void 0 ? void 0 : _props$properties.cornerIcon;
    });
    const isShowBuyButton = computed(() => {
      return SHOW_TYPE[props.properties.cartButtonType];
    });
    const isWaterfallFlow = computed(() => {
      return props.properties.displayQuantity === 0 && props.properties.showType !== LAYOUT_TYPE.HORIZONTAL;
    });
    const listClass = computed(() => {
      return props.properties.showType === LAYOUT_TYPE.TWO_COLUMN ? 'columns-two' : 'columns-three';
    });
    const moreIsShow = computed(() => {
      return SHOW_TYPE[props.properties.moreIsShow];
    });
    const onClickBuyPop = item => {
      closeToast();
      addCartList(item.selectedAsin, item.merchantId, 1, true, () => {
        showToastText(t('modules.checkout.SUCCESS_ADD_CART'), true, SHOW_TOAST_DURATION);
      });
    };
    onMounted(async () => {
      const {
        promotionList
      } = await getNewCustomerCoupon();
      couponInfo.value = (promotionList === null || promotionList === void 0 ? void 0 : promotionList.length) > 0 ? promotionList[0] : null;
      const recordParams = {
        pageName: route.name
      };
      awsRumHandler.recordClickEvent({
        ...clickEvents.landingPage.asinShowcaseWidget,
        ...recordParams
      });
    });
    return (_ctx, _cache) => {
      var _props$properties2;
      return _openBlock(), _createElementBlock("div", {
        class: "asin-showcase",
        style: _normalizeStyle(asinShowcaseStyle.value)
      }, [_createElementVNode("div", {
        class: "showcase-title",
        style: _normalizeStyle(masterTitleStyle.value)
      }, _toDisplayString(__props.properties.masterTitle), 5), _createElementVNode("div", {
        class: "showcase-sub-title",
        style: _normalizeStyle(deputyTitleStyle.value)
      }, _toDisplayString(__props.properties.deputyTitle), 5), __props.properties.showType === _unref(LAYOUT_TYPE).TWO_COLUMN || __props.properties.showType === _unref(LAYOUT_TYPE).THREE_COLUMN ? (_openBlock(), _createBlock(VerticalAsinShowCase, {
        key: 0,
        layoutType: __props.properties.layoutType,
        asinClass: listClass.value,
        asinIds: __props.properties.asinIds,
        isWaterfallFlow: isWaterfallFlow.value,
        asinBadge: asinBadge.value,
        isShowBuyButton: isShowBuyButton.value,
        displayQuantity: __props.properties.displayQuantity,
        moreIsShow: moreIsShow.value,
        interactionTypeInfo: __props.properties.interactionTypeInfo,
        customTextContent: __props.properties.customTextContent,
        onOnClickBuyPop: onClickBuyPop
      }, null, 8, ["layoutType", "asinClass", "asinIds", "isWaterfallFlow", "asinBadge", "isShowBuyButton", "displayQuantity", "moreIsShow", "interactionTypeInfo", "customTextContent"])) : (_openBlock(), _createBlock(HorizontalAsinShowCase, {
        key: 1,
        asinClass: listClass.value,
        asinIds: __props.properties.asinIds,
        asinBadge: asinBadge.value,
        isShowBuyButton: isShowBuyButton.value,
        displayQuantity: __props.properties.displayQuantity,
        moreIsShow: moreIsShow.value,
        interactionTypeInfo: (_props$properties2 = __props.properties) === null || _props$properties2 === void 0 ? void 0 : _props$properties2.interactionTypeInfo,
        customTextContent: __props.properties.customTextContent,
        onOnClickBuyPop: onClickBuyPop
      }, null, 8, ["asinClass", "asinIds", "asinBadge", "isShowBuyButton", "displayQuantity", "moreIsShow", "interactionTypeInfo", "customTextContent"]))], 4);
    };
  }
};